import { IAzureWebApp } from 'src/app/shared/interfaces/azure/webapp.interface';
import  AzureService  from 'src/app/shared/services/azure.service';
import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import DataStatus from 'src/app/shared/models/datastatus.class';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-azure-webapps-list',
  templateUrl: './webapps-list.component.html',
  styleUrls: ['./webapps-list.component.css']
})
export class WebappsListComponent implements OnInit, OnDestroy {

  public readonly testServerWebApps = signal<IAzureWebApp[]>([]);
  public dataStatus = new DataStatus();
  public searchBarContent: string = '';
  public readonly selectedContext = signal('Accountant');
  public readonly serviceType = signal<'app' | 'functionapp' | undefined>(undefined);

  private testServerWebAppsSubscription!: Subscription;

  constructor(private _azureService: AzureService, private _router: ActivatedRoute) { }

  ngOnInit(): void {
    this._router.url.subscribe({
      next: (segment) => {
        const path = segment[0].path;
        this.serviceType.set(this.discoverServiceType(path));

        this.loadTestServerWebApps(this.selectedContext(), this.serviceType());
      }
    })
  }

  ngOnDestroy(): void {
    if(this.testServerWebAppsSubscription) {
      this.testServerWebAppsSubscription.unsubscribe()
    }
  }

  public loadTestServerWebApps(context: string, serviceType?: 'app' | 'functionapp'): void {    
    this.dataStatus.loading.set(true);
    this.testServerWebApps.set([]);
    this.testServerWebAppsSubscription = this._azureService.getWebAppsByContext(`${context}-TestServer`, serviceType)
      .subscribe((webapps: IAzureWebApp[]) => {  
        if (webapps.length === 0) {
          this.dataStatus.empty.set(true);
          this.dataStatus.loading.set(false);
          return;
        }
        this.testServerWebApps.set(webapps);
        this.dataStatus.loading.set(false);
        this.dataStatus.completed.set(true);
        this.dataStatus.empty.set(false);
        this.selectedContext.set(context);
      });    
  }

  private discoverServiceType(path: string): 'app' | 'functionapp' {
    if (path === 'webapps') return 'app';
    else return 'functionapp';
  }
}
